import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { useEditedQuestionIndicator, useErrorQuestionIndicator } from "../../../../_shared/hooks";

import type { BasicCustomMailSettingFormData } from "../../../schema";
import type { UseFormReturn } from "react-hook-form";

type Props = {
	form: UseFormReturn<BasicCustomMailSettingFormData>;
};

export const ForExternal = ({ form }: Props) => {
	const {
		watch,
		setValue,
		formState: { errors },
	} = form;

	const externalLinkValue = watch("mailFooterExternalLink");

	// 値が入っているかどうかを監視（設定した項目がある場合に青丸を表示）
	useEditedQuestionIndicator("外部リンク設定", Boolean(externalLinkValue));
	// バリデーションエラーがある場合に赤丸を表示
	useErrorQuestionIndicator("外部リンク設定", Boolean(errors.mailFooterExternalLink));

	return (
		<div className="space-y-6">
			<div className="ml-2">
				{/* 外部リンク */}
				<div className="space-y-3">
					<InputTextField
						value={externalLinkValue || ""}
						handleChange={(value) =>
							setValue(
								"mailFooterExternalLink", //
								value,
								{ shouldDirty: true, shouldValidate: true },
							)
						}
						errorMessage={errors.mailFooterExternalLink?.message || ""}
						placeholder="https://example.com"
					/>
				</div>
			</div>
		</div>
	);
};
